import { getHistoryFromPutPass, getGuestFromPutPassEvent, localStorageItemAsHistory, localStorageItemAsGuest } from './selectors'
import db from './db'


function asUser(fn) {
  db.getItem('user', 'default', function (err, user) {
    if (!user) {
      return fn("Could not find user");
    } else {
      return fn(null, user);
    }
  });
}

function getHistory(callback) {
  setTimeout(() => {
    asUser((err, user) => {
      const { user_id } = user
      db.getItems(user_id, function (err, items) {
        const historyItems = items.map(localStorageItemAsHistory);
        return callback(null, historyItems);
      });
    });
  }, 500);
}
/**
 * 
 * @param {{guest_name:string,user_id:string}} pass 
 * @param {Function} callback 
 */
function putPass(_pass, callback) {
  setTimeout(() => {
    asUser(((err, user) => {
      const { user_id, user_name } = user;
      const pass = { ..._pass, user_id, user_name }
      const _event = getHistoryFromPutPass(pass);
      const _guest = getGuestFromPutPassEvent(_event);
      _event.pin = _guest.pin;
      db.putItem(_guest.guest_id, _event.timestamp, _guest, function (err) {
        if (err) { return callback(err); }
        db.putItem(_event.user_id, _event.timestamp, _event, function (err) {
          if (err) return callback(err);
          return callback(null);
        })
      });
    }))
  }, 500);
}
function checkGuestExists(guest_id, callback) {
  setTimeout(() => {
    db.getItems(guest_id, function (err, guests) {
      if (err) return callback(err);
      return callback(null, guests.length > 0);
    });
  }, 500);
}
/**
 * 
 * @param {string} guest_id 
 * @param {string} pin 
 * @param {function(err,{guest_name:string,guestPinIsValid:bool})} callback 
 */
function checkGuestPin(guest_id, pin, callback) {
  setTimeout(() => {
    db.getItems(guest_id, function (err, _guests) {
      if (err) return callback(err);
      if (_guests.length !== 1) return callback(`found unexpected number of guests: ${_guests.length}`);
      const guest = localStorageItemAsGuest(_guests[0]);
      return callback(null, {
        guest_name: guest.guest_name,
        guestPinIsValid: pin === guest.pin
      });
    });
  }, 750);
}
function submitGuestForm(guest_id, form, callback) {
  setTimeout(() => {
    return callback(null, "<QR CODE HERE>");
  }, 750)
}
/**
 * 
 * @param {*} code
 * @param {function(err,passFail)} callback 
 */
function checkPassCode(code, callback) {
  setTimeout(() => {
    if (code === "1234") return callback(null, true);
    else return callback(null, false);
  }, 1000);
}
export const api = {
  getHistory,
  putPass,
  checkGuestExists,
  checkGuestPin,
  submitGuestForm,
  checkPassCode
}


// WEBPACK FOOTER //
// ./src/util/mock/index.js